/**
 * for client
 */
export const INIT_USER_PROFILE = 'initUserProfile';
export const CLEAR_INIT_USER_PROFILE = 'clearInitUserProfile';
export const UPDATE_USER_PROFILE = 'updateUserProfile';